import React from 'react';
import {connect} from 'react-redux';
import { orgAdminAction, saveTeamDetailsAction, saveModulePermissionsAction, analyseActions } from '../_actions';
import { AnalyzeAction } from '../_actions/Analyze/analyze.action'
import {userListAction} from '../_actions/Analyze/userList.action'
import { headerPermissionAction } from '../_actions/Analyze/headerPermission.action'
import { competencyListAction } from '../_actions/Analyze/competencyList.action'
import { lndAction} from '../_actions/Analyze/lnd.action'
import { attritionPredictorAction } from '../_actions/Analyze/attritionPredictor.action'
import { getPaAnanlyzeTeamListAction } from '../_actions/Analyze/getPaAnanlyzeTeamList.action'
import { orientationAction } from '../_actions/Analyze/orientationAction.action'

import { superAdminAction, role_fitmentAction } from '../_actions';

class WrapperComponent extends React.Component {

    componentDidMount() {
        var pattern = /user/;
        var vPattern = /my-teams/;
        if(this.props.match.params.id !== undefined) {
            if(pattern.test(this.props.location.pathname) || vPattern.test(this.props.location.pathname)) {
                if(this.props.state.reloadValidatorReducer.data == false) {
                    this.props.dispatch({type: "RELOAD_TRUE"})
                    const { id } = this.props.match.params;
                    // this.props.dispatch(headerPermissionAction.headerPermissionDataAction({"analytics_org_id": id},(callback_data) => {
                    //     if(callback_data.data !== '') {
                    //         localStorage.setItem('is_org_admin',callback_data.data.is_org_admin)
                    //         localStorage.setItem('is_pa_user',callback_data.data.is_pa_user)
                    //         localStorage.setItem('is_success',callback_data.data.is_success)
                    //     }
                    // }))
                    const getModulePermissionListHandlerOb = {
                        "pa_user_email": localStorage.getItem('user_email'),
                        "organisation_id": +this.props.match.params.id
                    }
                    this.props.dispatch(orientationAction.orientationAPI_action(() => {
                        //User List
                        this.props.dispatch(userListAction.userListDataAction({"analytics_org_id":this.props.match.params.id}, (callback_user_list) => {
                        }))
                        
                        //Modules
                        this.props.dispatch(orgAdminAction.getModulePermissionListHandler(getModulePermissionListHandlerOb, (callback_Data) => {
                            const modulePermissions = callback_Data.data.message
                            this.props.dispatch(saveModulePermissionsAction.saveModulePermissionsHandler(callback_Data.data.message))
                            this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
                            
                            //bool constant
                            const get_role_fitment_permissions = modulePermissions.some((modulePerm => {
                                return modulePerm.module_list_id === 6
                            }))

                            //if rolefitment call fitment_list and holder_list
                            if(get_role_fitment_permissions) {
                                //no parallel callbacks for role fitment to avoid the sv_load
                                this.props.dispatch(role_fitmentAction.role_fitment_user_fitmentAction(() => {
                                    this.props.dispatch(role_fitmentAction.role_fitment_user_holderAction())
                                }))
                            }

                            const getPaUserPermissionListHandlerOb = {
                                "pa_user_email": localStorage.getItem('user_email'),
                                "analytic_organisation_id": +id,
                            }
                            
                            //Teams
                            this.props.dispatch(getPaAnanlyzeTeamListAction.getPaAnanlyzeTeamListDataAction(getPaUserPermissionListHandlerOb.analytic_organisation_id,(callback_Data) => {
                                var reformatdata = []
                                var tableData = callback_Data.data
                                for (var key in tableData) {
                                    if (tableData.hasOwnProperty(key)) {
                                        reformatdata = reformatdata.concat(tableData[key])
                                    }
                                }
            
                                var sortedArray =  reformatdata.sort(function(a, b) { 
                                    return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
                                });

                                const fd = {
                                    'teamName': sortedArray.length > 0 ? sortedArray[0].team_name : '',
                                    'teamId': sortedArray.length > 0 ? sortedArray[0].id : '',
                                    'orgId': id
                                }
                                localStorage.setItem('teamId', sortedArray.length > 0 ? sortedArray[0].id : '')
                                localStorage.setItem('teamName', sortedArray.length > 0 ? sortedArray[0].team_name : '')
                
                                this.props.dispatch(saveTeamDetailsAction.saveTeamDetailHandler(fd))
                                let assessorIds = [];
                                let assessmentIds = [];
                                if (sortedArray.length !== 0 && sortedArray !== '') {
            
                                    this.props.dispatch({
                                        type: "TEAMS_AVAILABLE",
                                        payload: ""
                                    })
            
                                    const team = {
                                        "team_id": sortedArray[0].id
                                    }
                                    //assessor_groups_for_team & team_members
                                    this.props.dispatch(analyseActions.getAssessorGroupsHandler(team,(callback_Data) => {

                                        

                                        

                                        const assessor_groups_for_team_temp = []
                                        callback_Data.data.assessor_groups_for_team.map(
                                            (data, i) => {
                                                assessor_groups_for_team_temp.push({
                                                    ...data,
                                                    'value': data.value
                                                })
                                            }
                                        )
                                        const fd1 = {
                                            'assessor_groups_for_team': assessor_groups_for_team_temp,
                                            'team_members': callback_Data.data.team_members
                                        }


                                        //team members and respondents
                                        this.props.dispatch(analyseActions.saveAssessorGroups(fd1))
                                        if(fd1.team_members.length > 1) {
                                            for (let i = 0; i < fd1.assessor_groups_for_team.length; i++) {
                                                if (fd1.assessor_groups_for_team[i].value === true) {
                                                    assessorIds.push(fd1.assessor_groups_for_team[i].id)
                                                }
                                            }
                                            for (let i = 0; i < fd1.team_members.length; i++) {
                                                assessmentIds.push(fd1.team_members[i].assessment.id)
                                            }

                                        }
                                        const fd3 = {
                                            "assessorIds": assessorIds,
                                            "assessmentIds": assessmentIds,
                                        }
                                        //Assessment id's and respondent id's
                                        this.props.dispatch(analyseActions.saveAssessorIds(fd3))
                                    }))
                                }
                                else {
                                    const fd3 = {
                                        "assessorIds": [],
                                        "assessmentIds": [],
                                    }
                                    const fd1 = {
                                        'assessor_groups_for_team': [],
                                        'team_members': []
                                    }

                                    //team members and respondents
                                    this.props.dispatch(analyseActions.saveAssessorGroups(fd1))
                                    //Assessment id's and respondent id's
                                    this.props.dispatch(analyseActions.saveAssessorIds(fd3))
                                    

                                    const postRequestObj = {"team_assessment_id": [],"relation_group_ids": []}
                                    const competencyPostObj = { "analytics_organisation": id }

                                    const competencyApi = {action: competencyListAction.competencyListDataAction, post: competencyPostObj}

                                    let UnsortedApiActions = [{action: AnalyzeAction.AnalyzeDataAction, post: postRequestObj}, {action: lndAction.lndDataAction, post: postRequestObj}, {action: attritionPredictorAction.attriPreDataAction, post: postRequestObj}]

                                    if(this.props.location.pathname.includes('learning-and-development')) {
                                        UnsortedApiActions = [UnsortedApiActions[1], UnsortedApiActions[2], UnsortedApiActions[0]]
                                    }else if(this.props.location.pathname.includes('attrition-predictor')) {
                                        UnsortedApiActions = [UnsortedApiActions[2], UnsortedApiActions[1], UnsortedApiActions[0]]
                                    }

                                    this.props.dispatch(competencyApi.action(competencyApi.post, () => {
                                        this.props.dispatch(UnsortedApiActions[0].action(UnsortedApiActions[0].post, () => {
                                            this.props.dispatch(UnsortedApiActions[1].action(UnsortedApiActions[1].post, () => {
                                                this.props.dispatch(UnsortedApiActions[2].action(UnsortedApiActions[2].post))
                                            }))
                                        }))
                                    }))

                                    this.props.dispatch({
                                        type: "NO_TEAMS_AVAILABLE",
                                        payload: "No Teams Available!"
                                    })
                                }
                            }))
                        }))
                    }))
    
                }
            }
            else {
                this.props.dispatch({type: "RELOAD_FALSE"})
            }
        }
    }

    render() {
        return (
            <div>{this.props.children}</div>
        )
    }
}

const mapStateToProps = state => ({state})

export default connect(mapStateToProps)(WrapperComponent)


// WEBPACK FOOTER //
// ./src/_components/PrivateRouteWrapper.jsx